import { Loading } from 'vnetwork-ui'

const LoadingBackdrop = () => {
    return (
        <div className="z-[9999] fixed inset-0 flex items-center justify-center text-bg-primary h-svh">
            <Loading.BarWave color="currentColor" />
        </div>
    )
}

export default LoadingBackdrop
